import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
	fill?: string;
};

export const SearchIcon = ({ sx, fill }: Props) => {
	return (
		<SvgIcon width='17' height='17' viewBox='0 0 17 17' fill='none' sx={sx}>
			<path
				d='M11.6195 10.9174H10.888L10.6287 10.6674C11.5362 9.61181 12.0824 8.24144 12.0824 6.7507C12.0824 3.42662 9.388 0.732178 6.06393 0.732178C2.73985 0.732178 0.0454102 3.42662 0.0454102 6.7507C0.0454102 10.0748 2.73985 12.7692 6.06393 12.7692C7.55467 12.7692 8.92504 12.2229 9.9806 11.3155L10.2306 11.5748V12.3063L14.8602 16.9266L16.2399 15.547L11.6195 10.9174ZM6.06393 10.9174C3.75837 10.9174 1.89726 9.05625 1.89726 6.7507C1.89726 4.44514 3.75837 2.58403 6.06393 2.58403C8.36948 2.58403 10.2306 4.44514 10.2306 6.7507C10.2306 9.05625 8.36948 10.9174 6.06393 10.9174Z'
				fill={fill ?? 'var(--mui-palette-text-primary)'}
				fillOpacity={fill ? '1' : '0.50'}
			/>
		</SvgIcon>
	);
};
